export const getFromSessionStorage = (props) => {
    const {key} = props
    try {
        const item = sessionStorage.getItem(key);
        return item && item !== "" ? JSON.parse(item) : null;
      } catch (e) {
        console.log(e);
        return null;
      }
}